module.exports = __webpack_public_path__ + "img/telephone2.75d667c7.png";